import { action } from 'satcheljs';

/**
 * Set the flag to denote accounts store is initialized
 */
export const setAccountStoreInitialized = action(
    'setAccountStoreInitialized',
    (initialized: boolean) => ({
        initialized,
    })
);
